import Vue from 'vue';
import { Button, Calendar, Row, Col, Scrollbar, Menu, Submenu, MenuItem, Breadcrumb, BreadcrumbItem, Container, Main, Alert, Tree, Rate } from 'element-ui';

Vue.use(Button);
Vue.use(Calendar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Scrollbar);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Container);
Vue.use(Main);
Vue.use(Alert);
Vue.use(Tree);
Vue.use(Rate);
